export default __webpack_public_path__ + "static/media/wireframe3.6e9d7e1f.svg";